import type { RouteLocationNormalized, RouteRecordRaw } from 'vue-router'
import store from '@/store'
import type { RouteAccessContext } from '@/router/access-map'
import { canAccessRouteByKey, resolveRouteAccessKey } from '@/router/access-utils'

// 统一兼容“已解析路由对象”和“静态路由配置”，便于在导航守卫、菜单过滤等场景复用同一套权限判断。
type RouteAccessTarget = Pick<RouteLocationNormalized, 'matched' | 'meta'> | RouteRecordRaw

// 从当前 store 中提取路由权限判断所需的最小上下文，避免调用方重复拼装用户状态。
// 这里返回的是“调用当下”的快照对象，适合即时权限判断，不应被长时间缓存后复用。
export function createRouteAccessContext(): RouteAccessContext {
  return {
    userId: store.authStore.user.user_id,
    superAdmin: store.authStore.superAdmin,
    hiddenCommissionModule: store.authStore.hiddenCommissionModule,
    isBuHeaderView: store.globalSearchStore.isBuHeaderView,
  }
}

// 路由权限控制的统一入口：
// 1. 先从路由记录上解析 accessKey；
// 2. 再结合当前用户上下文命中对应规则；
// 3. 未配置 accessKey 的路由默认放行。
export function canAccessRoute(route: RouteAccessTarget, context = createRouteAccessContext()): boolean {
  return canAccessRouteByKey(resolveRouteAccessKey(route), context)
}
